/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Services_TitleInputs */

const en_meta_services_title = /** @type {(inputs: Meta_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Automation Services: AI Agents, Agent Teams, Research & AI Systems | Lindevo`)
};

const lv_meta_services_title = /** @type {(inputs: Meta_Services_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI automatizācija, AI aģenti, aģentu komandas un AI sistēmas | Lindevo`)
};

/**
* | output |
* | --- |
* | "AI Automation Services: AI Agents, Agent Teams, Research & AI Systems \| Lindevo" |
*
* @param {Meta_Services_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_services_title = /** @type {((inputs?: Meta_Services_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Services_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_services_title(inputs)
	return en_meta_services_title(inputs)
});